import { render, staticRenderFns } from "./mtp-periods.vue?vue&type=template&id=d6afa59c"
import script from "./mtp-periods.ts?vue&type=script&lang=ts&external"
export * from "./mtp-periods.ts?vue&type=script&lang=ts&external"
import style0 from "./mtp-periods.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6afa59c')) {
      api.createRecord('d6afa59c', component.options)
    } else {
      api.reload('d6afa59c', component.options)
    }
    module.hot.accept("./mtp-periods.vue?vue&type=template&id=d6afa59c", function () {
      api.rerender('d6afa59c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin-periods/mtp-periods/mtp-periods.vue"
export default component.exports